import * as React from "react";

import { cn } from "@/lib/core/utils";

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(({ className, type, ...props }, ref) => {
  return (
    <input
      {...props}
      ref={ref}
      type={type ?? "text"}
      className={cn(
        "flex h-11 w-full min-w-0 max-w-full truncate rounded-md border border-input bg-background px-3 py-2 text-sm text-slate-700 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:truncate placeholder:font-normal placeholder:text-slate-400 focus-visible:bg-highlight-bg focus-visible:border-transparent focus-visible:outline-none focus-visible:shadow-highlight focus-visible:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:border-angels-purple/20 disabled:bg-angels-purple/5 disabled:text-angels-purple/70 disabled:placeholder:text-angels-purple/40 disabled:focus-visible:shadow-none disabled:focus-visible:bg-angels-purple/5 read-only:cursor-default read-only:focus-visible:shadow-none read-only:focus-visible:border-input read-only:focus-visible:bg-background md:h-10",
        className
      )}
    />
  );
});
Input.displayName = "Input";

export { Input };
